import sendToServer from './send-to-server';
import trackEvent from './track-event';

const CareerRating = {
  init() {
    if (!($('.career-rating').length > 0)) return;
    trackEvent('Careers', 'completed', $('.header h2').html());
    $('.star').click(this.handleStarClick.bind(this));
    $('.interested').click(this.handleInterestedClick.bind(this));
    $('.next-career').click(this.handleNextCareerClick.bind(this));
    $('.recommendation').click(this.handleRecommendationClick.bind(this));
    $('.make-favourite').click(this.handleFavouriteMakerClick.bind(this));
    $('.show-page-two').click(this.handlePageTwoClick.bind(this));
    $('.enabler').keyup(this.handleEnablerTyping.bind(this));
  },

  handleStarClick(event) {
    let $chosenStar = $(event.target);
    $('.star').each((_index, element) => {
      let $star = $(element);
      if ($star.data('rating') <= $chosenStar.data('rating')) {
        $star.addClass('selected');
      } else {
        $star.removeClass('selected');
      }
    });

    trackEvent('Careers', 'rated', $('.header h2').html(), $chosenStar.data('rating'));

    sendToServer('/api/v2/career_relationships/' + $('.career-rating').data('career-id'),
                 { rating: $chosenStar.data('rating') },
                 null,
                 "PATCH");

    this.brieflyShowRatingConfirmation();
  },

  handleInterestedClick(event) {
    $('.interested-section').fadeOut();
    trackEvent('Careers', 'registered interest', $('.header h2').html());
    sendToServer('/api/v2/career_relationships/' + $('.career-rating').data('career-id'),
                 { interested: true },
                 null,
                 "PATCH");
    this.brieflyShowInterestConfirmation();
  },

  handleNextCareerClick(event) {
    if ($('.recommendation-box').length > 0) {
      trackEvent('Careers', 'recommendation offered');
      sendToServer('/api/v2/events',
                 { event: 'saw_recommendation',
                   career_id: $('.recommendation-box').data('career-id') });
      $('.next-career').hide();
      $('.recommendation-box').fadeIn();
    } else {
      window.location = '/app/careers';
    }
  },

  handleFavouriteMakerClick() {
    $('.favourite-section').fadeOut();
    sendToServer('/api/v2/career_relationships/' + $('.career-rating').data('career-id'),
                 { favourite: true },
                 null,
                 "PATCH");
    this.brieflyShowFavouriteConfirmation();
  },

  handleRecommendationClick() {
    sendToServer('/api/v2/events',
                 { event: 'tried_recommendation',
                   career_id: $('.recommendation-box').data('career-id') });
    trackEvent('Careers', 'recommendation accepted');
  },

  brieflyShowRatingConfirmation() {
    this.brieflyShow('.rating-success-message')
  },

  brieflyShowInterestConfirmation() {
    this.brieflyShow('.interest-success-message')
  },

  brieflyShowFavouriteConfirmation() {
    this.brieflyShow('.favourite-success-message')
  },

  brieflyShow(selector) {
    window.setTimeout(()=>{ $(selector).fadeOut() }, 3000)
    $(selector).fadeIn();
  },

  handlePageTwoClick() {
    if ($('.show-page-two').prop('disabled')) return;
    $('.page-one').hide();
    $('.page-two').show();
  },

  handleEnablerTyping() {
    if ($('#positive').val() && $('#negative').val()) {
      $('.show-page-two').prop('disabled', false)
     } else {
      $('.show-page-two').prop('disabled', true)
    }

    if ($('#price').val()) {
      $('.submitter').prop('disabled', false)
     } else {
      $('.submitter').prop('disabled', true)
    }
  }
};

$(document).ready(()=> {
  CareerRating.init();
});
